import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Input, Row, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import firebase from 'firebase';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import UserContext from '../../../layout/UserContext';
import checkPermission from '../../../../components/Authorization/Util';
import ImageUploader from '../../../../firebase/ImageUploader';
// import ColorPicker from '../../../../components/ColorPicker/ColorPicker';
// import InputColour from '../../../../components/InputColour';

const General = ({ reportData, form, submit }) => {
  const [iconFileDetails, setIconFileDetails] = useState([]);
  const [logoFileDetails, setLogoFileDetails] = useState([]);
  const [aboutImageFileDetails, setAboutImageFileDetails] = useState([]);
  const [mainColour, setMainColour] = useState(
    reportData && reportData.mainColour ? reportData.mainColour : '#ffffff',
  );
  // const [secondaryColour, setSecondaryColour] = useState(
  //   reportData && reportData && reportData.secondaryColour
  //     ? reportData.secondaryColour
  //     : '#ffffff',
  // );

  useEffect(() => {
    
    if (reportData && reportData && reportData.mainColour) {
      setMainColour(reportData.mainColour);
    }

    // if (reportData && reportData && reportData.secondaryColour) {
    //   setSecondaryColour(reportData.secondaryColour);
    // }
  }, [reportData]);

  const onLogoUploadSuccessHandleForm = value => {
    
    setLogoFileDetails(value);

    form.setFieldsValue({
      image: value,
    });
    
  };

  const onIconUploadSuccessHandleForm = value => {
    
    setIconFileDetails(value);

    form.setFieldsValue({
      icon: value,
    });
    
  };

  const onAboutImageUploadSuccessHandleForm = value => {
    
    setAboutImageFileDetails(value);

    form.setFieldsValue({
      aboutImage: value,
    });
    console.log(
      'onUploadSuccessHandleForm: fileDetailsList',
      aboutImageFileDetails,
    );
  };

  const getLogoDraggerValue = () => {
    
    const draggerValue = form.getFieldValue('image');
    return draggerValue;
  };

  const getIconDraggerValue = () => {
    
    const draggerValue = form.getFieldValue('icon');
    return draggerValue;
  };

  const getAboutImageDraggerValue = () => {
    
    const draggerValue = form.getFieldValue('aboutImage');
    return draggerValue;
  };

  const { getFieldDecorator } = form;

  const value = useContext(UserContext);
  const disable = !checkPermission(value, 'appcms', 'write');

  return (
    <>
      <Row>
        <Col span={13}>
          <Row>
            <Col span={24}>
              <Card bordered={false}>
                <Form.Item label="Website">
                  {getFieldDecorator('websiteLink', {
                    rules: [],
                    initialValue:
                      reportData && reportData && reportData.websiteLink
                        ? reportData.websiteLink
                        : undefined,
                  })(<Input disabled={disable} />)}
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Main Colour&nbsp;
                      <Tooltip title="Enter Hex colour code. This colour is used for menu and main sections in the app.">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                >
                  {getFieldDecorator('mainColour', {
                    rules: [],
                    initialValue:
                      reportData && reportData && reportData.mainColour
                        ? reportData.mainColour
                        : undefined,
                  })(
                    // <ColorPicker record={(reportData)? reportData.mainColour : undefined}  />
                    // <ColorPicker onChange={mainColourChange()} />
                    // <InputColour  color={reportData && reportData.mainColour}/>
                    <Input
                      disabled={disable}
                      onChange={e => setMainColour(e.target.value)}
                      suffix={
                        <>
                          {/* <Tooltip title="Enter Hex color code">
                            <InfoCircleOutlined />
                          </Tooltip> */}
                          <Button
                            style={{
                              background: mainColour,
                              marginLeft: '10px',
                            }}
                          >
                            {' '}
                          </Button>
                        </>
                      }
                    />,
                  )}
                </Form.Item>

                {/* <Form.Item
                  label={
                    <span>
                      Secondary Colour&nbsp;
                      <Tooltip title="Enter Hex colour code. This colour is used for selected items in the app.">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                >
                  {getFieldDecorator('secondaryColour', {
                    rules: [],
                    initialValue:
                      reportData && reportData && reportData.secondaryColour
                        ? reportData.secondaryColour
                        : undefined,
                  })(
                    <Input
                      disabled={disable}
                      onChange={e => setSecondaryColour(e.target.value)}
                      suffix={
                        <>
                          <Button
                            style={{
                              background: secondaryColour,
                              marginLeft: '10px',
                            }}
                          >
                            {' '}
                          </Button>
                        </>
                      }
                    />,
                    // <ColorPicker record={(reportData)? reportData.secondaryColour : undefined}  />
                    // <InputColour  color={reportData && reportData && reportData.secondaryColour ? reportData && reportData && reportData.secondaryColour: '#ffffff'}/>
                  )}
                </Form.Item> */}
                {/* <Form.Item label="POI Preview mode">
                  {getFieldDecorator('previewModeOn', {
                    valuePropName: 'checked',
                    initialValue:
                      reportData && reportData && reportData.previewModeOn
                        ? reportData.previewModeOn
                        : undefined,
                  })(<Switch disabled={disable} />)}
                </Form.Item> */}
              </Card>
              <Card bordered={false} id="aboutImage">
                <Form.Item
                  wrapperCol={{ xs: { span: 24 } }}
                  style={{ display: 'flex', marginTop: '-25px' }}
                >
                  {getFieldDecorator('aboutImage', {
                    valuePropName: 'file',
                  })(
                    <Card
                      title={
                        <span>
                          About Image&nbsp;
                          <Tooltip title="The selected image is shown at the header in the About page.">
                            <InfoCircleOutlined />
                          </Tooltip>
                        </span>
                      }
                    >
                      <Row justify="center">
                        <div className="clearfix">
                          <ImageUploader
                            storageRef={firebase
                              .storage()
                              .ref(
                                window.location.hostname.split('.')[0] +
                                  '/about-images',
                              )}
                            handleFormValue={
                              onAboutImageUploadSuccessHandleForm
                            }
                            getDraggerValue={getAboutImageDraggerValue}
                            storageFolder={
                              window.location.hostname.split('.')[0] +
                              '/about-images'
                            }
                            imageListData={
                              reportData && reportData
                                ? reportData.aboutImage
                                : undefined
                            }
                            disabledAdd={
                              !checkPermission(value, 'appcms', 'write')
                            }
                            accept="image/*"
                            maxCount={1}
                            submit={submit}
                          />
                        </div>
                      </Row>
                    </Card>,
                  )}
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col span={11}>
          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('image', {
                valuePropName: 'file',
              })(
                <Card
                  title={
                    <span>
                      Logo&nbsp;
                      <Tooltip title="The selected image is shown in the splash page.">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                >
                  <Row justify="center">
                    <div className="clearfix">
                      <ImageUploader
                        storageRef={firebase
                          .storage()
                          .ref(
                            window.location.hostname.split('.')[0] +
                              '/logo-images',
                          )}
                        handleFormValue={onLogoUploadSuccessHandleForm}
                        getDraggerValue={getLogoDraggerValue}
                        storageFolder={
                          window.location.hostname.split('.')[0] +
                          '/logo-images'
                        }
                        imageListData={
                          reportData && reportData
                            ? reportData.image
                            : undefined
                        }
                        disabledAdd={!checkPermission(value, 'appcms', 'write')}
                        accept="image/*"
                        maxCount={1}
                        submit={submit}
                      />
                    </div>
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('icon', {
                valuePropName: 'file',
              })(
                <Card
                  title={
                    <span>
                      Icon&nbsp;
                      <Tooltip title="The selected image is used as the app's icon.">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                >
                  <Row justify="center">
                    <div className="clearfix">
                      <ImageUploader
                        storageRef={firebase
                          .storage()
                          .ref(
                            window.location.hostname.split('.')[0] +
                              '/icon-images',
                          )}
                        handleFormValue={onIconUploadSuccessHandleForm}
                        getDraggerValue={getIconDraggerValue}
                        storageFolder={
                          window.location.hostname.split('.')[0] +
                          '/icon-images'
                        }
                        imageListData={
                          reportData && reportData ? reportData.icon : undefined
                        }
                        disabledAdd={!checkPermission(value, 'appcms', 'write')}
                        accept="image/*"
                        maxCount={1}
                        submit={submit}
                      />
                    </div>
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </>
  );
};

General.propTypes = {
  form: PropTypes.object,
  reportData: PropTypes.object,
  submit: PropTypes.func,
};

General.contextType = UserContext;

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(General);
